@if (stageLabel; as stage) {
    <div
        class="fixed top-0 z-[1100] flex h-6 w-full items-center justify-center bg-yellow-300 px-4 text-center text-xs font-bold uppercase tracking-wide text-black"
        role="status"
        aria-live="polite"
    >
        {{ 'app.stage-environment-banner' | translate: { stage: stage } }}
    </div>
}

<sag-ui-application-frame
    [class.stage-banner-active]="!!stageLabel"
    [applicationName]="'app.title' | translate"
    [logoUrl]="'assets/images/sag-logo/sie-logo-petrol-rgb.svg'"
    [logoUrlDark]="'assets/images/sag-logo/sie-logo-white-rgb.svg'"
    [logoAlt]="'app.logo-alt' | translate"
    [sidebarItems]="authService.isAuthenticated() && !isRouterPathUnauthorized() ? sidebarItems() : []"
    [bottomSidebarItems]="authService.isAuthenticated() && !isRouterPathUnauthorized() ? bottomSidebarItems() : []"
    [userRoles]="authService.userIdTokenClaims()?.roles || []"
    [skipToContentTarget]="'#main-content'"
    [skipToContentTargetLinkText]="'app.skip-to-main-content-link' | translate"
    [footerLinks]="footerLinks()"
    (sidebarItemClicked)="openCreateWorkflowDialog()"
>
    <ng-template #desktopHeaderContent>
        <app-header-menu class="flex items-center gap-2" />
    </ng-template>

    <ng-template #mobileHeaderContent>
        <app-header-menu class="flex flex-col-reverse space-y-4 w-full" />
    </ng-template>

    <!-- Main content area -->
    <div
        class="bg-light-bgColorPrimary dark:bg-dark-bgColorPrimary"
        [class.px-4]="!isRouterPathUnauthorized()"
        id="main-content"
    >
        @if (!authService.isAuthLoading()) {
            <router-outlet />
        } @else {
            <div class="flex flex-col justify-center gap-4 items-center h-[calc(100vh-11rem)]">
                <sag-ui-spinner size="lg" [ariaLabel]="'general.loading' | translate" />
                <p>{{ 'general.loading' | translate }}</p>
            </div>
        }
    </div>
</sag-ui-application-frame>
<app-create-workflow-handler></app-create-workflow-handler>
